import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { showSensitiveInfoState } from '~/state/atoms/viewerAtoms';
import { formatSeriesDate } from '~/utils/date';
import { distinguishingSeriesNumber } from '~/viewportGrid';

/**
 * What an image list says after an image's name: the date it was acquired
 * while patient information is shown; while it is hidden, the series number
 * in its place, so images of one modality still differ while their names
 * and dates are masked. With neither known, nothing.
 */
export default function ImageListMeta({
    date,
    seriesNumber,
}: {
    date: Date | undefined;
    seriesNumber: number | undefined;
}) {
    const intl = useIntl();
    const namesShown = useRecoilValue(showSensitiveInfoState);
    const seriesNumberLabel = distinguishingSeriesNumber(
        intl,
        seriesNumber,
        namesShown
    );
    if (seriesNumberLabel !== undefined) {
        return (
            <Typography
                variant="monoMeta"
                color="text.secondary"
                flexShrink={0}
            >
                {seriesNumberLabel}
            </Typography>
        );
    }
    return date ? (
        <Typography variant="monoMeta" color="text.secondary" flexShrink={0}>
            <SensitiveInfoTypography>
                {formatSeriesDate(date)}
            </SensitiveInfoTypography>
        </Typography>
    ) : null;
}
